import React, { useState, useEffect, useCallback } from 'react'
import _ from 'lodash'
import { TiWarningOutline } from 'react-icons/ti'

import * as InvoicesAndReceiptsConstants from '../helpers/constants'
import * as Constants from '../../../../../helpers/constants'
import { ApiHelper } from '../../../../../helpers/apihelper'
import showToastNotification from '../../../../widgets/toastify'
import PendingInvoicesTable from '../../../../tables/invoices_and_receipts/pending_invoices'


const initialState = {
  pendingInvoices: []
}

const PendingInvoices = ({ data, client }) => {
  const [state, setState] = useState(initialState)

  const getPendingInvoices = useCallback(() => {
    let requestQueryParams = {
      co_user_id: data.user_id || data._id,
      cop_user_id: data.user_id,
      client_secret: Constants.CLIENT_SECRET,
    }

    let queryParams = _.pick(requestQueryParams, ApiHelper(client, 'PENDING_INVOICE').API_QUERY)

    ApiHelper(client, 'PENDING_INVOICE').API(client, queryParams)
      .then((response) => {
        if (response.status === Constants.CO_API.SUCCESS) {
          setState(prevState => ({
            ...prevState,
            pendingInvoices: response.data.invoices
          }))
        } else {
          showToastNotification({
            message: response.message,
            isSuccess: false,
          })
        }
      })
      .catch((err) => {
        console.log('pending invoice list failed: ', err)
        showToastNotification({
          message: err.message,
          isSuccess: false,
        })
      })
  }, [data.user_id, client, data._id])

  useEffect(() => {
    getPendingInvoices()
  }, [getPendingInvoices])

  const columns = InvoicesAndReceiptsConstants.PENDING_INVOICE_TABLE_COLUMNS[client]

  if (_.isEmpty(state.pendingInvoices)) {
    return null
  }

  return (
    <>
      <div className='invoice-recept-table'>
        <h5 className='billing-tab-headers mt-4'>
          <TiWarningOutline
            className='text-danger mr-1'
            size={'1.2em'}
          />
          Pending Invoices
        </h5>
        <PendingInvoicesTable
          data={state.pendingInvoices}
          columns={columns}
        />
      </div>
    </>
  )
}

export default PendingInvoices
